export const ipfGLCoefficients = {
  male: {
    classic: [1199.72839, 1025.18162, 0.00921],
    equipped: [1236.25115, 1449.21864, 0.01644],
  },
  female: {
    classic: [610.32796, 1045.59282, 0.03048],
    equipped: [758.63878, 949.31382, 0.02435],
  },
} as const;
export type GLSex = keyof typeof ipfGLCoefficients;
export type GLCategory = "classic" | "equipped";
export function calculateIPFGL(
  bodyweight: number,
  total: number,
  sex: GLSex,
  category: GLCategory,
) {
  if (
    !Number.isFinite(bodyweight) ||
    bodyweight <= 0 ||
    !Number.isFinite(total) ||
    total <= 0
  )
    throw new Error("Vücut ağırlığı ve toplam pozitif olmalıdır.");
  const [a, b, c] = ipfGLCoefficients[sex][category];
  const denominator = a - b * Math.exp(-c * bodyweight);
  if (denominator <= 0)
    throw new Error("Bu vücut ağırlığı için geçerli puan hesaplanamıyor.");
  const coefficient = Math.round((100 / denominator) * 1e6) / 1e6;
  return { coefficient, points: Math.round(coefficient * total * 1e6) / 1e6 };
}
